import { TextNode } from 'lexical';

const EMOJI_REGEX = /\p{Extended_Pictographic}/u;

export const $addEmojiNodeConfig = (nodes) => {
  nodes.push(EmojiNode);
};

export const $createEmojiNode = (emoji) => {
  const emojiNode = new EmojiNode(emoji);

  emojiNode.setMode('segmented').toggleDirectionless();

  return emojiNode;
};

const convertEmojiElement = (domNode) => {
  const textContent = domNode.textContent;

  if (textContent !== null) {
    return {
      node: $createEmojiNode(textContent),
    };
  }

  return null;
};

class EmojiNode extends TextNode {
  __emoji;

  constructor(emoji, key) {
    super(emoji, key);
    this.__emoji = emoji;
  }

  static clone(node) {
    return new EmojiNode(node.__text, node.__key);
  }

  static getType() {
    return 'emoji';
  }

  static importJSON(serializedNode) {
    const node = $createEmojiNode(serializedNode.emoji);

    node.setTextContent(serializedNode.text);
    node.setFormat(serializedNode.format);
    node.setDetail(serializedNode.detail);
    node.setMode(serializedNode.mode);
    node.setStyle(serializedNode.style);

    return node;
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      emoji: this.__emoji,
      type: 'emoji',
      version: 1,
    };
  }

  createDOM(config) {
    return super.createDOM(config);
  }

  updateDOM() {
    return false;
  }

  exportDOM() {
    return { element: this.__text };
  }

  static importDOM() {
    return {
      span: (domNode) => {
        if (!EMOJI_REGEX.test(domNode.innerHTML.trim())) {
          return null;
        }

        return {
          conversion: convertEmojiElement,
          priority: 1,
        };
      },
    };
  }

  isTextEntity() {
    return true;
  }

  canInsertTextBefore() {
    return false;
  }

  canInsertTextAfter() {
    return false;
  }
}
